module.exports = __webpack_public_path__ + "img/沧源县人民医院.dc34715b.png";